(() => {
  const HARD_STYLE_ID = 'tvx-footer-hard-fix-v4';
  const mobileQuery = window.matchMedia('(max-width:900px)');

  const hardCss = `
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter > p,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter .tvx-footer-panel__trigger,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter .tvx-footer-panel__body,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter .tvx-footer-panel__inner,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter form,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter fieldset,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-newsletter fieldset > p,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn > p,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn .tvx-footer-panel__trigger,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn .tvx-footer-panel__body,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn .tvx-footer-panel__inner,
html body #root footer.shopify-section-footer nav#shopify-section-footer .m6cn .tvx-footer-panel__inner > p {
  background:transparent!important;
  background-color:transparent!important;
  background-image:none!important;
  box-shadow:none!important;
}

html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__body,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__inner {
  color:#11131A!important;
  -webkit-text-fill-color:#11131A!important;
}

html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger::before,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger::after,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger *::before,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger *::after {
  display:none!important;
  content:none!important;
  background:none!important;
  border:0!important;
  width:0!important;
  height:0!important;
  opacity:0!important;
  visibility:hidden!important;
}
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel .toggle,
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel i[class*="chevron-down"],
html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel i[class*="chevron-up"] {
  display:none!important;
  visibility:hidden!important;
  opacity:0!important;
}

html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer input[type="email"] {
  box-sizing:border-box!important;
  background:#fff!important;
  background-color:#fff!important;
  color:#11131A!important;
  -webkit-text-fill-color:#11131A!important;
}

@media (max-width:900px) {
  html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel {
    background:transparent!important;
    background-color:transparent!important;
    box-shadow:none!important;
    border-bottom:1px solid rgba(17,19,26,.10)!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__trigger {
    cursor:default!important;
    pointer-events:none!important;
    padding-right:0!important;
    background:transparent!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__body,
  html body #root footer.shopify-section-footer nav#shopify-section-footer .tvx-footer-panel__inner {
    display:block!important;
    width:100%!important;
    height:auto!important;
    max-height:none!important;
    overflow:visible!important;
    opacity:1!important;
    visibility:visible!important;
    transform:none!important;
    background:transparent!important;
  }

  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer {
    display:block!important;
    width:100%!important;
    max-width:100%!important;
    height:auto!important;
    overflow:visible!important;
    opacity:1!important;
    visibility:visible!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer fieldset {
    display:grid!important;
    grid-template-columns:minmax(0,1fr)!important;
    gap:10px!important;
    width:100%!important;
    max-width:100%!important;
    height:auto!important;
    margin:0!important;
    padding:0!important;
    overflow:visible!important;
    opacity:1!important;
    visibility:visible!important;
    background:transparent!important;
    border:0!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer fieldset > p:first-of-type {
    display:block!important;
    position:static!important;
    grid-column:1!important;
    width:100%!important;
    max-width:100%!important;
    height:auto!important;
    min-height:52px!important;
    margin:10px 0 0!important;
    padding:0!important;
    overflow:visible!important;
    opacity:1!important;
    visibility:visible!important;
    clip:auto!important;
    clip-path:none!important;
    transform:none!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer input[type="email"] {
    display:block!important;
    position:static!important;
    float:none!important;
    box-sizing:border-box!important;
    width:100%!important;
    min-width:0!important;
    max-width:100%!important;
    height:54px!important;
    min-height:54px!important;
    margin:0!important;
    padding:0 16px!important;
    opacity:1!important;
    visibility:visible!important;
    clip:auto!important;
    clip-path:none!important;
    transform:none!important;
    pointer-events:auto!important;
    z-index:2!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer p.submit,
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer p.submit.mobile-hide {
    display:block!important;
    position:static!important;
    float:none!important;
    grid-column:1!important;
    width:100%!important;
    min-width:0!important;
    max-width:100%!important;
    height:auto!important;
    margin:0!important;
    padding:0!important;
    overflow:visible!important;
    opacity:1!important;
    visibility:visible!important;
    transform:none!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer p.submit button[type="submit"] {
    display:flex!important;
    position:static!important;
    float:none!important;
    box-sizing:border-box!important;
    width:100%!important;
    min-width:0!important;
    max-width:100%!important;
    height:54px!important;
    min-height:54px!important;
    margin:0!important;
    padding:0 18px!important;
    align-items:center!important;
    justify-content:center!important;
    white-space:nowrap!important;
    overflow:hidden!important;
    border-radius:12px!important;
    border:1px solid #245BDB!important;
    background:#245BDB!important;
    background-color:#245BDB!important;
    color:#fff!important;
    -webkit-text-fill-color:#fff!important;
    font-size:12px!important;
    font-weight:900!important;
    letter-spacing:.055em!important;
    line-height:1!important;
    text-align:center!important;
    text-indent:0!important;
    box-shadow:0 9px 22px rgba(36,91,219,.18)!important;
  }
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer p.submit button[type="submit"]:hover,
  html body #root footer.shopify-section-footer nav#shopify-section-footer #newsletter-footer p.submit button[type="submit"]:focus-visible {
    border-color:#1744AF!important;
    background:#1744AF!important;
    background-color:#1744AF!important;
    color:#fff!important;
    -webkit-text-fill-color:#fff!important;
  }
}
`;

  const ensureHardStyle = () => {
    let style = document.getElementById(HARD_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = HARD_STYLE_ID;
      document.head.appendChild(style);
    }
    if (style.textContent !== hardCss) style.textContent = hardCss;

    const oldStyle = document.getElementById('tvx-footer-hard-fix-v3');
    if (oldStyle && oldStyle !== style) oldStyle.remove();
  };

  const findDirectFooterColumn = (element, footer) => {
    let node = element;
    while (node && node.parentElement && node.parentElement !== footer) node = node.parentElement;
    return node?.parentElement === footer ? node : null;
  };

  const removeLegacyArrow = (panel, trigger) => {
    if (!panel) return;
    panel.querySelectorAll('.toggle').forEach((item) => item.remove());
    trigger?.querySelectorAll('i[class*="chevron-down"], i[class*="chevron-up"]').forEach((item) => item.remove());
  };

  const forceTransparentPanel = (panel) => {
    if (!panel) return;
    panel.style.setProperty('background', 'transparent', 'important');
    panel.style.setProperty('background-color', 'transparent', 'important');
    panel.style.setProperty('box-shadow', 'none', 'important');

    panel.querySelectorAll('.tvx-footer-panel__trigger, .tvx-footer-panel__body, .tvx-footer-panel__inner').forEach((node) => {
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('background-color', 'transparent', 'important');
      node.style.setProperty('box-shadow', 'none', 'important');
    });
  };

  const makePanelStatic = (panel, key) => {
    if (!panel) return;

    if (panel.dataset.tvxFooterPanel === 'true') {
      const trigger = panel.querySelector('.tvx-footer-panel__trigger');
      const body = panel.querySelector('.tvx-footer-panel__body');
      panel.classList.add('is-open');
      removeLegacyArrow(panel, trigger);
      trigger?.removeAttribute('role');
      trigger?.removeAttribute('tabindex');
      trigger?.removeAttribute('aria-expanded');
      trigger?.removeAttribute('aria-controls');
      body?.removeAttribute('aria-hidden');
      forceTransparentPanel(panel);
      return;
    }

    const heading = panel.querySelector('h1,h2,h3,h4,h5,h6');
    const trigger = heading?.parentElement;
    if (!heading || !trigger) return;

    panel.dataset.tvxFooterPanel = 'true';
    panel.classList.add('tvx-footer-panel', 'is-open');
    trigger.classList.add('tvx-footer-panel__trigger');
    removeLegacyArrow(panel, trigger);

    const body = document.createElement('div');
    body.className = 'tvx-footer-panel__body';
    body.id = `tvx-footer-${key}-body`;

    const inner = document.createElement('div');
    inner.className = 'tvx-footer-panel__inner';

    const movingNodes = [];
    let current = trigger.nextSibling;
    while (current) {
      movingNodes.push(current);
      current = current.nextSibling;
    }
    movingNodes.forEach((node) => inner.appendChild(node));
    body.appendChild(inner);
    panel.appendChild(body);

    trigger.removeAttribute('role');
    trigger.removeAttribute('tabindex');
    trigger.removeAttribute('aria-expanded');
    trigger.removeAttribute('aria-controls');
    body.removeAttribute('aria-hidden');
    forceTransparentPanel(panel);
  };

  const updateCtaCopy = (button) => {
    if (!button) return;

    if (!button.dataset.tvxOriginalCta) {
      button.dataset.tvxOriginalCta = button.textContent.trim() || 'Subscribe';
    }

    const label = mobileQuery.matches ? 'GET FIRST ACCESS' : button.dataset.tvxOriginalCta;
    if (button.textContent.trim() !== label) button.textContent = label;
    button.setAttribute(
      'aria-label',
      mobileQuery.matches ? 'Get first access to new drops and restocks' : button.dataset.tvxOriginalCta
    );
  };

  const forceNewsletterVisible = (newsletterForm) => {
    if (!newsletterForm) return;

    newsletterForm.querySelector('fieldset > p:first-of-type > button[type="submit"]')?.remove();

    const emailRow = newsletterForm.querySelector('fieldset > p:first-of-type');
    const emailInput = newsletterForm.querySelector('input[type="email"]');
    const submitRow = newsletterForm.querySelector('p.submit');
    const universalSubmit = submitRow?.querySelector('button[type="submit"]');

    submitRow?.classList.remove('mobile-hide');
    universalSubmit?.classList.add('tvx-footer-subscribe');
    updateCtaCopy(universalSubmit);

    if (emailRow) {
      emailRow.style.setProperty('display', 'block', 'important');
      emailRow.style.setProperty('visibility', 'visible', 'important');
      emailRow.style.setProperty('opacity', '1', 'important');
      emailRow.style.setProperty('height', 'auto', 'important');
      emailRow.style.setProperty('overflow', 'visible', 'important');
    }
    if (emailInput) {
      emailInput.style.setProperty('display', 'block', 'important');
      emailInput.style.setProperty('visibility', 'visible', 'important');
      emailInput.style.setProperty('opacity', '1', 'important');
      emailInput.style.setProperty('position', 'static', 'important');
      emailInput.style.setProperty('box-sizing', 'border-box', 'important');
      emailInput.style.setProperty('width', '100%', 'important');
      emailInput.style.setProperty('min-width', '0', 'important');
      emailInput.style.setProperty('max-width', '100%', 'important');
      emailInput.style.setProperty('height', mobileQuery.matches ? '54px' : '52px', 'important');
    }
    if (submitRow && mobileQuery.matches) {
      submitRow.style.setProperty('display', 'block', 'important');
      submitRow.style.setProperty('position', 'static', 'important');
      submitRow.style.setProperty('width', '100%', 'important');
      submitRow.style.setProperty('min-width', '0', 'important');
      submitRow.style.setProperty('max-width', '100%', 'important');
      submitRow.style.setProperty('margin', '0', 'important');
    }
    if (universalSubmit && mobileQuery.matches) {
      universalSubmit.style.setProperty('display', 'flex', 'important');
      universalSubmit.style.setProperty('position', 'static', 'important');
      universalSubmit.style.setProperty('box-sizing', 'border-box', 'important');
      universalSubmit.style.setProperty('width', '100%', 'important');
      universalSubmit.style.setProperty('min-width', '0', 'important');
      universalSubmit.style.setProperty('max-width', '100%', 'important');
      universalSubmit.style.setProperty('height', '54px', 'important');
    }
  };

  const enhanceFooter = () => {
    ensureHardStyle();

    const footer = document.querySelector('#shopify-section-footer');
    if (!footer) return;

    const supportPanel = footer.querySelector('.m6cn');
    makePanelStatic(supportPanel, 'help');

    const newsletterForm = footer.querySelector('#newsletter-footer');
    const newsletterPanel = newsletterForm ? findDirectFooterColumn(newsletterForm, footer) : null;
    newsletterPanel?.classList.add('tvx-footer-newsletter');
    makePanelStatic(newsletterPanel, 'newsletter');
    forceNewsletterVisible(newsletterForm);

    [supportPanel, newsletterPanel].forEach(forceTransparentPanel);

    footer.querySelectorAll('.tvx-footer-panel').forEach((panel) => {
      panel.classList.add('is-open');
      const trigger = panel.querySelector('.tvx-footer-panel__trigger');
      const body = panel.querySelector('.tvx-footer-panel__body');
      removeLegacyArrow(panel, trigger);
      trigger?.removeAttribute('role');
      trigger?.removeAttribute('tabindex');
      trigger?.removeAttribute('aria-expanded');
      trigger?.removeAttribute('aria-controls');
      body?.removeAttribute('aria-hidden');
      forceTransparentPanel(panel);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFooter, { once: true });
  } else {
    enhanceFooter();
  }

  document.addEventListener('shopify:section:load', enhanceFooter);
  mobileQuery.addEventListener?.('change', enhanceFooter);

})();
